var warning = function warning() {};
/* istanbul ignore next */


if (process.env.NODE_ENV !== 'production') {
  warning = function warning(component, message) {
    // eslint-disable-next-line no-console
    console.error("Warning: [".concat(component, "] ").concat(message));
  };
}

var validVariable = function validVariable(isValid) {
  if (!isValid) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    warning.apply(void 0, args);
  }
};

export { warning, validVariable };